import { useCallback, useEffect, useState } from "react";
import { faqCategory } from "../../../../constant";
import { useLocale, useService } from "../../../../hooks";

export const useFaq = () => {
  const { t } = useLocale();
  const { fetchAll } = useService("Data", "faq");
  const { setTitle } = useService("Meta");
  const { showAlert } = useService("Misc");
  const [faqList, setfaqList] = useState([]);
  const [activeFaq, setactiveFaq] = useState(null);
  const [activeCategory, setactiveCategory] = useState(faqCategory[0]);
  const [filteredFaqList, setfilteredFaqList] = useState([]);

  const getFaqsData = useCallback(async () => {
    let result = await fetchAll();
    if (result.status) {
      if (result.data?.length === 0)
        showAlert({ type: "error", msg: t("errorMsg.fail.faqNotFound") });
      else setfaqList(result.data);
      setactiveCategory(faqCategory[0]);
    }
  }, [fetchAll, showAlert, t]);

  setTitle("FAQs");
  useEffect(() => {
    if (faqList.length === 0) getFaqsData();
  }, [getFaqsData, faqList]);

  useEffect(() => {
    let filteredFaqList = [];
    faqList.forEach((e) => {
      if (JSON.parse(e.category).value === activeCategory.value)
        filteredFaqList.push(e);
    });
    setfilteredFaqList(filteredFaqList);
  }, [activeCategory, faqList]);
  return {
    setactiveFaq,
    activeFaq,
    activeCategory,
    setactiveCategory,
    category: faqCategory,
    filteredFaqList,
  };
};
